import React, { useState, useEffect } from "react";
import "./switch.scss";

const Switch = ({
    initialState = "off",
    isOn, 
    onChange,
    disabled,
    label,
    labelPosition = "right",
}) => {
        const controlled = typeof isOn === "boolean";

    const [state, setState] = useState(() =>
        disabled
            ? initialState === "on"
                ? "disabled-on"
                : "disabled-off"
            : initialState
    );
    // si se usa como controlado, sincronizar el estado visual cuando cambie isOn o disabled
    useEffect(() => {
        if (controlled) {
            if (disabled) {
                setState(isOn ? "disabled-on" : "disabled-off");
            } else {
                setState(isOn ? "on" : "off");
            }
        } else {
            // si no es controlado pero cambia disabled, ajustamos la representación visual
            setState((prev) => {
                const base = prev.includes("disabled") ? prev.replace("disabled-", "") : prev;
                return disabled ? `disabled-${base}` : base;
            });
        }
    }, [isOn, controlled, disabled]);

    const toggle = () => {
        if (disabled) return;
        // estado actual como booleano
        const currentOn = state === "on" || state === "disabled-on";
        const nextOn = !currentOn;

        // si no es controlado actualizamos el state interno
        if (!controlled) {
            setState(nextOn ? "on" : "off");
        }

        // notificar cambio con booleano (nextOn)
        onChange?.(nextOn);
    };

    return (
        <div className={`switch-container ${labelPosition}`}>
            {label && labelPosition === "left" && (
                <span className="switch__label">{label}</span>
            )}

            <button
                className={`switch ${state}`}
                onClick={toggle}
                disabled={disabled}
                                aria-pressed={state === "on" || state === "disabled-on"}

            >
                <span className="slider" />
            </button>

            {label && labelPosition === "right" && (
                <span className="switch__label">{label}</span>
            )}
        </div>
    );
};

export default Switch;
